import React, { FC } from 'react';

import type { DynamicMediaSectionProps } from './DynamicMediaSection.types';

export const DynamicMediaSection: FC<DynamicMediaSectionProps> = ({ section, query, resetQuery, Component }) => (
  <Component section={section} query={query} resetQuery={resetQuery} />
);
